angular.module('bribac.components.insuranceDataEditor',
    ['bribac.values', 'bribac.translations', 'bribac.services.api']
)
    .component('insuranceDataEditor', {
        templateUrl: 'insurance-data-editor-component.html',
        controller: 'InsuranceDataEditorCtrl',
        bindings: {
            insurance: '<',
            successCallback: '<',
            cancelCallback: '<',
            onLoadCompanies: '&',
            onLoadProviders: '&',
            onLoadSubscribers: '&',
            onSubscriberChange: '&',
        }
    })
    .controller('InsuranceDataEditorCtrl', function ($scope, api, KINDS) {
        const $ctrl = this;

        $ctrl.isInsuranceFormOpen = false;
        $ctrl.isSubjectSubscriber = false;

        $ctrl.insuranceFields = [
            {
                key: 'policyNumber',
                label: 'components.insuranceDataDetails.labels.subscriber.policyNumber',
                required: true,
                shouldDisplay: true
            },
            {
                key: 'groupNumber',
                label: 'components.insuranceDataDetails.labels.subscriber.groupNumber',
                required: false,
                shouldDisplay: true
            },
            {
                key: 'insuranceRenderingProvider',
                label: 'components.insuranceDataDetails.labels.subscriber.insuranceRenderingProvider',
                required: false,
                shouldDisplay: true
            },
            {
                key: 'insuranceReferringProvider',
                label: 'components.insuranceDataDetails.labels.subscriber.insuranceReferringProvider',
                required: false,
                shouldDisplay: true
            },
            {
                key: 'subscriberRelation',
                label: 'components.insuranceDataDetails.labels.subscriber.relationship',
                required: true,
                shouldDisplay: true
            },
        ];

        function initializeInsuranceData() {
            $ctrl.editableInsurance = $ctrl.insurance || {};

            $ctrl.insuranceFields.forEach((field) => {
                if ($ctrl.editableInsurance[field.key] === undefined) {
                    $ctrl.editableInsurance[field.key] = '';
                }
            });

            populateInsuranceData();
        }

        $ctrl.handleSubscriberChange = function() {
            $ctrl.onSubscriberChange({ value: $ctrl.isSubjectSubscriber });

            const subscriberRelationField = $ctrl.insuranceFields.find(field => field.key === 'subscriberRelation');

            if (subscriberRelationField) {
                subscriberRelationField.shouldDisplay = !$ctrl.isSubjectSubscriber;
            }
        };

        function submitSuccess(request) {
            $ctrl.form._submitSuccess = 'Saved ' + request.data.policyNumber
            resetForm()
            $ctrl.successCallback(request.data)
        }

        $ctrl.onSubmit = function () {
            var $form = $ctrl.form

            if ($form._submitting) return

            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields'
                return
            }

            $form._submitSuccess = ''
            $form._submitError = ''

            submitSuccess({data: $ctrl.editableInsurance})
        }

        function loadProviders() {
            const filter = $ctrl.mainGroup && $ctrl.mainGroup.id ? `?mainGroupId=${$ctrl.mainGroup.id}` : '';
            $ctrl.insuranceProviderPromise = api.getFilteredByOrg(KINDS.INSURANCE_PROVIDER + '/list', filter).then(function (response) {
                $ctrl.insuranceProvider = response.data || [];
                $ctrl.onLoadProviders({providers: $ctrl.insuranceProvider});
            });
        }

        function loadSubscribers() {
            const filter = $ctrl.mainGroup && $ctrl.mainGroup.id ? `?mainGroupId=${$ctrl.mainGroup.id}` : '';
            $ctrl.insuranceSubscriberPromise = api.getFilteredByOrg(KINDS.INSURANCE_SUBSCRIBER + '/list', filter).then(function (response) {
                $ctrl.insuranceSubscriber = response.data || [];
                $ctrl.onLoadSubscribers({subscribers: $ctrl.insuranceSubscriber});
            });
        }

        function loadCompanies() {
            const filter = $ctrl.mainGroup && $ctrl.mainGroup.id ? `?mainGroupId=${$ctrl.mainGroup.id}` : '';
            $ctrl.insuranceCompanyPromise = api.getFilteredByOrg(KINDS.INSURANCE_COMPANY + '/list', filter).then(function (response) {
                $ctrl.insuranceCompany = response.data || [];
                $ctrl.onLoadCompanies({companies: $ctrl.insuranceCompany});
            });
        }

        function populateInsuranceData() {
            if ($ctrl.editableInsurance) {
                if ($ctrl.editableInsurance.insuranceProvider) {
                    $ctrl.editableInsurance.insuranceProviderId = $ctrl.editableInsurance.insuranceProvider.id;
                }

                if ($ctrl.editableInsurance.insuranceSubscriber) {
                    $ctrl.editableInsurance.insuranceSubscriberId = $ctrl.editableInsurance.insuranceSubscriber.id;

                }

                if ($ctrl.editableInsurance.insuranceCompany) {
                    $ctrl.editableInsurance.insuranceCompanyId = $ctrl.editableInsurance.insuranceCompany.id;
                }
            }
        }

        $ctrl.$onInit = function () {
            $ctrl.form = {};
            initializeInsuranceData();
            loadProviders();
            loadSubscribers();
            loadCompanies();
        };

        $scope.$watch('$ctrl.mainGroup', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                loadProviders();
                loadSubscribers();
                loadCompanies();
            }
        });

        function resetForm() {
            if ($ctrl.form) {
                $ctrl.form.$setUntouched()
                $ctrl.form.$setPristine()
            }
        }

        $ctrl.$onChanges = function (insurance) {
            if (insurance) {
                resetForm();
                populateInsuranceData();
            }
        }
    });